module.exports = __webpack_public_path__ + "static/img/cont35 (6).a7c0ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (6).jpg
// module id = 76+w
// module chunks = 0